// scanJobTracking — hand an accepted scan upload over to ScanJobWatcher.
//
// `scan-upload` answers with the `document_jobs` id the pipeline keeps working on.
// Marking the file "accepted" with that id keeps its „Zadania w tle” item in
// progress until the watcher resolves the job; without a followable id the item
// ends at "accepted by the server", as before.
import type { MarkUploadItem } from "@ds/actions/useUploadProcess";

/** Process `type` of a „Ponów przetwarzanie” batch from /dokumenty — one item per
 *  re-run job (item id = job id), followed by ScanJobWatcher like an accepted upload. */
export const SCAN_RERUN_PROCESS_TYPE = "scan-rerun";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** `document_jobs.id` is a uuid — anything else can't be followed. */
export function isTrackableJobId(v: unknown): v is string {
  return typeof v === "string" && UUID.test(v);
}

export function markScanAccepted(
  mark: MarkUploadItem,
  key: string,
  result: { jobId?: unknown } | null | undefined,
  processingMessage: string,
): void {
  const jobId = result?.jobId;
  if (isTrackableJobId(jobId)) mark(key, "accepted", { jobId, message: processingMessage });
  else mark(key, "success");
}
